import { Ref, ref } from "vue";

const appContainer: Ref<HTMLElement | null> = ref(null);
export default () => {
  const scrollAppContainer = (top = 0) => {
    if (appContainer.value) {
      appContainer.value.scrollTo({ top, behavior: "smooth" });
    }
  };

  return {
    appContainer,
    scrollAppContainer,
  };
};
